export const getLanguages = (state) => state.cache.languages;
export const getProductCategories = (state) => state.productCategory.mainProductCategories;
